import { EcommerceProductItem, ProductItem } from '../../cart/CartEvents.model';
import { CheckoutStepType } from '@spartacus/checkout/base/root';

export interface CustomCheckoutStepsModel {
  checkout: {
    actionField?: {
      step: number,
      option: string,
    },
    products?: Array<ProductItem>,
  };
}

export interface CustomCheckoutModel {
  currency: string;
  value: number;
  coupon: string;
  shipping_tier?: string;
  payment_type?: string;
  items: Array<EcommerceProductItem>
}

export enum CustomCheckoutStepType {
  SHIPPING_ADDRESS = 'shippingAddress',
  DELIVERY_MODE = 'deliveryMode',
  PAYMENT_DETAILS = 'paymentDetails',
  REVIEW_ORDER = 'reviewOrder',
  PAYMENT_TYPE = 'paymentType',
}

export const checkoutShippingSteps = [
  CheckoutStepType.DELIVERY_ADDRESS,
  CheckoutStepType.DELIVERY_MODE,
];

export const checkoutPaymentSteps = [
  CheckoutStepType.PAYMENT_DETAILS,
  CheckoutStepType.PAYMENT_TYPE,
  CheckoutStepType.DELIVERY_ADDRESS,
];

export const customCheckoutPaymentSteps = [
  CheckoutStepType.PAYMENT_DETAILS,
  CheckoutStepType.PAYMENT_TYPE,
  CheckoutStepType.DELIVERY_ADDRESS,
];
